export const COOPERANT_STOCKS_PERMISSIONS = {
    READ: 'cooperant_stocks_read',
    CREATE: 'cooperant_stocks_create',
    UPDATE: 'cooperant_stocks_update'
} as const
